'use client';

export const ZmyleLogo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 356.408 89.972">
      <defs>
        <style>{'.a{fill:none}'}</style>
        <clipPath id="a">
          <path className="a" d="M0 0h356.408v-89.972H0z" />
        </clipPath>
        <clipPath id="b">
          <path
            className="a"
            d="M5.669-89.972A5.67 5.67 0 000-84.3v78.631A5.669 5.669 0 005.669 0H84.3a5.67 5.67 0 005.67-5.669V-84.3a5.671 5.671 0 00-5.67-5.67H5.669zM45.5-33.447a44.129 44.129 0 0020.245-4.447 30.039 30.039 0 0013.141-12.413l5.877 3.055a36.929 36.929 0 01-8.221 14 42.377 42.377 0 01-13.867 10.2 40.862 40.862 0 01-16.4 3.793h-1.731a40.935 40.935 0 01-16.71-3.547 42.554 42.554 0 01-14.175-10.2 36.762 36.762 0 01-8.451-14.246l5.878-3.055a29.126 29.126 0 0012.677 12.223 43.361 43.361 0 0019.7 4.637H45.5z"
          />
        </clipPath>
        <linearGradient
          id="c"
          y1={0.325}
          x2={0.292}
          y2={0.325}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fd317a" />
          <stop offset={0.1} stopColor="#f8317a" />
          <stop offset={0.2} stopColor="#f33179" />
          <stop offset={0.3} stopColor="#ed3179" />
          <stop offset={0.4} stopColor="#e83178" />
          <stop offset={0.5} stopColor="#e23177" />
          <stop offset={0.6} stopColor="#dc3177" />
          <stop offset={0.7} stopColor="#d73176" />
          <stop offset={0.8} stopColor="#d13076" />
          <stop offset={0.9} stopColor="#cb3075" />
          <stop offset={1} stopColor="#c63075" />
        </linearGradient>
      </defs>
      <g clipPath="url(#a)" transform="translate(0 89.972)">
        <path
          d="M0 0v-7.764h-39.536V2.861h22.527l-23.211 30.69v8.025H.73V30.951h-24.124zm8.983-7.764v49.34h13.179V6.691a8.54 8.54 0 018.117-4.651q4.059 0 5.746 1.915t1.687 6.2v31.421h13.179L50.846 7.7q2.279-5.66 8.208-5.66 4.149 0 5.791 1.938t1.642 6.133v31.465h13.224v-31.51Q79.711.671 75.79-4T63.842-8.676q-9.623 0-14.82 7.524-3.558-7.524-13.088-7.524-8.934 0-14.182 6.429l-.411-5.517zm90.109 0H84.91l17.283 49.477-1.551 4.059a7.494 7.494 0 01-2.895 3.785 10.855 10.855 0 01-5.586 1.14l-2.007-.046v9.987a20.758 20.758 0 005.837.866q10.168 0 14.592-9.667l1.1-2.6 19.837-57h-14.142l-9.12 30.689zm51.53-20.7H137.4v70.041h13.224zM195.4 40.14a19.767 19.767 0 008.026-6.544l-6.475-7.25q-4.287 5.517-11.9 5.517a11.645 11.645 0 01-8.14-2.918 12.246 12.246 0 01-3.854-7.752h31.42v-5.381q0-11.72-5.814-18.1t-15.938-6.388a22.843 22.843 0 00-12.016 3.169 21.088 21.088 0 00-8.14 9.029 29.813 29.813 0 00-2.869 13.293v1.277q0 11.081 6.818 17.739t17.67 6.657A26.34 26.34 0 00195.4 40.14m-6.245-35.786a9.811 9.811 0 012.371 6.8v1.054h-18.332a13.753 13.753 0 013.124-7.6 8.23 8.23 0 016.361-2.657 8.5 8.5 0 016.476 2.405"
          fill="#0e2545"
          transform="translate(151.931 -61.504)"
        />
      </g>
      <g clipPath="url(#b)" transform="translate(0 89.972)">
        <path
          d="M19.473-53.656l347.96 77.141-19.473 87.839L0 34.183z"
          fill="url(#c)"
          transform="rotate(-12.5 -156.063 17.093)"
        />
      </g>
    </svg>
  );
};
